import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SwitchToOldDashBanner } from '@dev/ee-components';
import { useSelector } from 'react-redux';
import { getGeneralInfo } from '@/store/account/actions';

const StyledBanner = styled.div`
    .typography-text-box {
        font-weight: 600;
        
    }
`;

export const PilotPlanBanner = () => {
    const { productCode } = useCurrentPlanStatus();
    const {UserName} = useSelector(getGeneralInfo);
    const { t } = useTranslation();
    const redirectToBilling = () => {
        window.location.href = `${location.origin}${BillingPaths.BillingPlanList.replace(
            pathsParams.productCode,
            productCode?.toLowerCase?.()
        )}`;
    };

    return (
        <StyledBanner>
            <SwitchToOldDashBanner
                hideBannerBorder
                hideIcon
                text={t('pilotplan_warning',{accountemail: UserName })}
                buttonText={t('upgrade')}
                buttonOnClick={redirectToBilling}
                isCustomBranding={false}
                isOwnedByReseller={false}
                accountCreationDateUtc={null}
                buttonId="upgrade-pilot-plan"
            />
        </StyledBanner>
    );
};
